<template>
    <div class="main-panel">


        <section>
            <h1>Dashboard</h1>
            <div class="grid">
                <div>
                    <canvas ref="pieChartRef"></canvas>
                </div>

                <div>
                    <canvas ref="lineChartRef"></canvas>
                </div>
            </div>
            <div class="grid-3">
                <div>
                    <canvas ref="barChartRef"></canvas>
                </div>

                <div>
                    <canvas ref="donutChartRef"></canvas>
                </div>

                <div>
                    <canvas ref="radarChartRef"></canvas>
                </div>

                <div>
                    <canvas ref="polarAreaChartRef"></canvas>
                </div>
            </div>
        </section>
    </div>
</template>

<script lang="ts">
    import { defineComponent, onMounted, ref } from 'vue';
    import { Chart, registerables } from 'chart.js';
    import { TitleOptions } from 'chart.js';

    Chart.register(...registerables);

    export default defineComponent({
        setup() {
            const pieChartRef = ref(null);
            const lineChartRef = ref(null);
            const barChartRef = ref(null);
            const donutChartRef = ref(null);
            const radarChartRef = ref(null);
            const polarAreaChartRef = ref(null);

            onMounted(() => {
                const chartOptions = (title) => ({
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        title: {
                            display: true,
                            text: title,
                            font: {
                                size: 18,
                                weight: 'bold'
                            },
                            color: '#333'
                        } as TitleOptions, // Cast to TitleOptions to fix typing issue
                    }
                });

                if (pieChartRef.value) {
                    new Chart(pieChartRef.value, {
                        type: 'pie',
                        data: {
                            labels: ['comp 1', 'comp 2', 'comp 3'],
                            datasets: [{
                                data: [30, 50, 20],
                                backgroundColor: ['#ff6384', '#36a2eb', '#ffce56'],
                            }],
                        },
                        options: chartOptions('Tickets Sold')
                    });
                }

                if (lineChartRef.value) {
                    new Chart(lineChartRef.value, {
                        type: 'line',
                        data: {
                            labels: ['12am', '01am', '02am', '03am'],
                            datasets: [
                                {
                                    label: 'All Competitions',
                                    data: [10, 50, 15, 250],
                                    borderColor: '#36a2eb',
                                    fill: false,
                                },
                             
                            ],
                        },
                        options: chartOptions('Completed Orders')
                    });
                }
                if (barChartRef.value) {
                    new Chart(barChartRef.value, {
                        type: 'bar',
                        data: {
                            labels: ['Q1', 'Q2', 'Q3', 'Q4'],
                            datasets: [{
                                label: 'Revenue',
                                data: [200, 300, 400, 500],
                                backgroundColor: ['#ff6384', '#36a2eb', '#ffce56', '#4bc0c0'],
                            }],
                        },
                        options: chartOptions('Bar Chart')
                    });
                }

                if (donutChartRef.value) {
                    new Chart(donutChartRef.value, {
                        type: 'doughnut',
                        data: {
                            labels: ['Product A', 'Product B', 'Product C'],
                            datasets: [{
                                data: [40, 30, 30],
                                backgroundColor: ['#ff6384', '#36a2eb', '#ffce56'],
                            }],
                        },
                        options: chartOptions('Doughnut Chart')
                    });
                }

                if (radarChartRef.value) {
                    new Chart(radarChartRef.value, {
                        type: 'radar',
                        data: {
                            labels: ['Speed', 'Strength', 'Agility', 'Endurance', 'Skill'],
                            datasets: [{
                                label: 'Athlete Stats',
                                data: [65, 75, 70, 80, 60],
                                borderColor: '#ff6384',
                                backgroundColor: 'rgba(255,99,132,0.2)',
                            }],
                        },
                        options: chartOptions('Radar Chart')
                    });
                }

                if (polarAreaChartRef.value) {
                    new Chart(polarAreaChartRef.value, {
                        type: 'polarArea',
                        data: {
                            labels: ['A', 'B', 'C', 'D', 'E'],
                            datasets: [{
                                data: [11, 16, 7, 14, 22],
                                backgroundColor: ['#ff6384', '#36a2eb', '#ffce56', '#4bc0c0', '#9966ff'],
                            }],
                        },
                        options: chartOptions('Polar Area Chart')
                    });
                }
            });

            return { pieChartRef, lineChartRef, barChartRef, donutChartRef, radarChartRef, polarAreaChartRef };
        }
    });
</script>

<style scoped>
    .grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 3rem;
        padding-bottom: 2rem;
    }


    @media (max-width: 800px) {
        .grid {
            grid-template-columns: 1fr;
        }
    }

    .grid-3 {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
        gap: 3rem;
    }

    section {
        --col-1: #4cff00;
        padding: 4rem 2rem;
    }


    h1 {
        font-size: 1.8em;
        color: #726e6e;
        margin-bottom: 20px;
    }

    canvas {
        max-width: 100%;
        background-color: white;
        padding: 2rem;
        border-radius: 3px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
        border: 8px solid #ececec;
    }
</style>